export default __webpack_public_path__ + "static/media/icon_5.895bbb13.svg";